// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__MJGBX"};